import { Modal, ModalHeader } from "reactstrap";

type ModalWindowProps = {
  children: React.ReactNode;
  open: boolean;
  onCloseRequest: () => void;
  header?: string;
  size?: string;
};

export const ModalWindow = ({
  children,
  open,
  size,
  header,
  onCloseRequest: onClose,
}: ModalWindowProps) => {
  return (
    <div>
      <Modal isOpen={open} toggle={onClose} size={size}>
        <ModalHeader tag="h2" toggle={onClose}>
          {header ?? ""}
        </ModalHeader>
        {children}
      </Modal>
    </div>
  );
};
